import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { LinearProgress } from '@mui/material';
import { LicenseInfo } from '@mui/x-license-pro';
import { QueryClientProvider } from 'react-query';
import { queryClient } from './hooks/config';
import routes from './routes';
import { PrimeReactProvider } from 'primereact/api';

const toastContainerAutoCloseSeconds = 5000;
LicenseInfo.setLicenseKey(process.env.REACT_APP_DATAGRID_LICENSE);

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <div className='App'>
        <PrimeReactProvider>
          <React.Suspense fallback={<LinearProgress />}>
            <RouterProvider router={routes} />
          </React.Suspense>
          <ToastContainer
            autoClose={toastContainerAutoCloseSeconds}
            position={toast.POSITION.BOTTOM_RIGHT}
          />
        </PrimeReactProvider>
      </div>
    </QueryClientProvider>
  );
}

export default App;
